package uz.ferro.shop.model

data class FilterComboData(
    val property: Property,
    val values: List<String>,
    var selectedValue: String? = null
)
